import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('obie-contact-form-general', wrap(Vue, () => import('~root/src/components/ContactFormGeneral.vue?shadow')))

window.customElements.define('obie-contact-form-risk-review', wrap(Vue, () => import('~root/src/components/ContactFormRiskReview.vue?shadow')))

window.customElements.define('obie-insurance-savings-calculator', wrap(Vue, () => import('~root/src/components/InsuranceSavingsCalculator.vue?shadow')))

window.customElements.define('obie-market-rates', wrap(Vue, () => import('~root/src/components/MarketRates.vue?shadow')))

window.customElements.define('obie-mortgage-calculator', wrap(Vue, () => import('~root/src/components/MortgageCalculator.vue?shadow')))

window.customElements.define('obie-nest-egg-calculator', wrap(Vue, () => import('~root/src/components/NestEggCalculator.vue?shadow')))

window.customElements.define('obie-net-lease-insurance-calculator', wrap(Vue, () => import('~root/src/components/NetLeaseInsuranceCalculator.vue?shadow')))

window.customElements.define('obie-refinance-calculator', wrap(Vue, () => import('~root/src/components/RefinanceCalculator.vue?shadow')))

window.customElements.define('obie-sign-up-form', wrap(Vue, () => import('~root/src/components/SignUpForm.vue?shadow')))